import { render, staticRenderFns } from "./Remessa.vue?vue&type=template&id=1a08693a&scoped=true"
import script from "./Remessa.vue?vue&type=script&lang=js"
export * from "./Remessa.vue?vue&type=script&lang=js"
import style0 from "./Remessa.vue?vue&type=style&index=0&id=1a08693a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08693a",
  null
  
)

export default component.exports